module.exports = __webpack_public_path__ + "43068c60.png";